module.exports = __webpack_public_path__ + "img/rvt.15701e7b.png";